import { Scope } from '@talpor/react-context-manager';

import api, { request } from '../../api';
import { IStore } from '../index';

export interface ISurveysActions extends Scope<IStore> {
  getSurveys: (state: IStore) => (team: string, platform: string) => Promise<IStore>;
  sendAnswers: (
    state: IStore
  ) => (
    team: string,
    platform: string,
    member: string,
    answers: number[],
    survey: string
  ) => Promise<IStore>;
}

export const surveysActions: ISurveysActions = {
  getSurveys: (state: IStore) => async (team: string, platform: string) => {
    const surveys = await request.get(api.surveys(team, platform));

    if (surveys.error) {
      return {
        ...state,
        misc: {
          loading: false,
          notification: {
            status: true,
            message: surveys.error.body.message.message,
            type: 'error',
          },
        },
      };
    }

    return {
      surveys: {
        currentSurvey: surveys.currentSurvey,
        surveys: surveys.surveys,
      },
      misc: {
        loading: false,
        notification: {
          status: false,
          message: '',
          type: 'success',
        },
      },
    } as IStore;
  },
  sendAnswers: (state: IStore) => async (
    team: string,
    platform: string,
    member: string,
    answers: number[],
    survey: string
  ) => {
    const data = { team, platform, member, answers, survey };
    const answersResponse = await request.post(api.answers, data);

    if (answersResponse.error) {
      return {
        ...state,
        misc: {
          loading: false,
          notification: {
            status: true,
            message: answersResponse.error.body.message.message,
            type: 'error',
          },
        },
      };
    }

    return {
      misc: {
        loading: false,
        notification: {
          status: false,
          message: '',
          type: 'success',
        },
      },
    } as IStore;
  },
};
